import axiosInstance from '../../../services/axios';
import { commonActions } from '../CommonSlice';
import { environmentActions } from './EnvironmentSlice';

export const fetchAllEnvironmentsInTestSuite = (suiteId) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axiosInstance({
        method: 'get',
        url: `/v1/test_suites/${suiteId}/environments`
      });
      const data = response.data;
      return data;
    };
    try {
      dispatch(commonActions.showLoadingIcon(true));
      const environments = await fetchData();
      dispatch(environmentActions.updateEnvironmentList(environments));
      dispatch(commonActions.showLoadingIcon(false));
    } catch (error) {
      dispatch(commonActions.showLoadingIcon(false));
    }
  };
};

export const fetchEnvironmentById = (suiteId, id) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axiosInstance({
        method: 'get',
        url: `/v1/test_suites/${suiteId}/environments/${id}?expand=true`
      });
      const data = response.data;
      return data;
    };
    try {
      dispatch(commonActions.showLoadingIcon(true));
      const environment = await fetchData();
      dispatch(environmentActions.updateEnvironment(environment));
      dispatch(commonActions.showLoadingIcon(false));
    } catch (error) {
      dispatch(commonActions.showLoadingIcon(false));
    }
  };
};

export const createEnvironment = (suiteId, environmentData) => {
  return (dispatch) => {
    const addData = async () => {
      await axiosInstance({
        method: 'post',
        url: `/v1/test_suites/${suiteId}/environments`,
        data: environmentData
      });
    };
    try {
      return addData();
    } catch (error) {
      dispatch(commonActions.showLoadingIcon(false));
    }
  };
};

export const updateEnvironment = (suiteId, id, environmentData) => {
  return (dispatch) => {
    const updateData = async () => {
      await axiosInstance({
        method: 'put',
        url: `/v1/test_suites/${suiteId}/environments/${id}`,
        data: environmentData
      });
    };
    try {
      return updateData();
    } catch (error) {
      dispatch(commonActions.showLoadingIcon(false));
    }
  };
};

export const deleteEnvironment = (suiteId, id) => {
  return (dispatch) => {
    const deleteData = async () => {
      await axiosInstance({
        method: 'delete',
        url: `/v1/test_suites/${suiteId}/environments/${id}`
      });
    };
    try {
      return deleteData();
    } catch (error) {
      dispatch(commonActions.showLoadingIcon(false));
    }
  };
};
